import React from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
export function SolutionSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#FAF7F2] text-center relative overflow-hidden" data-id="element-259">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-260">
        <FadeInView data-id="element-261">
          <h2 className="text-4xl md:text-6xl font-bold text-[#1B4332] mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-262">
            🏆 ADELGAZA CON AIR FRYER
          </h2>

          <p className="text-xl md:text-2xl font-medium text-[#2D5016] mb-6" data-id="element-263">
            El sistema completo de alimentación saludable para perder peso sin
            pasar hambre
          </p>

          <p className="text-lg text-[#2D5016]/80 mb-12 max-w-2xl mx-auto" data-id="element-264">
            6 libros especializados + 3 bonos estratégicos. Todo listo para usar
            desde hoy.
          </p>

          {/* 6 Books Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mb-16" data-id="element-265">
            {/* Book 1 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-266">
              <div className="text-5xl mb-4" data-id="element-267">📗</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-268">
                LIBRO 1 — Cómo Adelgazar con Air Fryer
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-269">
                La base del sistema
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-270">
                La guía maestra que explica exactamente cómo funciona la pérdida
                de peso cocinando con freidora de aire. Qué comer, qué evitar,
                cómo combinar alimentos y por qué este método funciona cuando
                todo lo demás ha fallado.
              </p>
            </div>

            {/* Book 2 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-271">
              <div className="text-5xl mb-4" data-id="element-272">📙</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-273">
                LIBRO 2 — Recetas del Día a Día
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-274">
                El motor del sistema
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-275">
                Más de 50 recetas diseñadas específicamente para adelgazar.
                Desayunos, comidas y cenas que se preparan en menos de 20
                minutos. Pollo crujiente, salmón dorado, verduras asadas,
                aperitivos saludables. Comida real que te apetece comer cada
                día.
              </p>
            </div>

            {/* Book 3 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-276">
              <div className="text-5xl mb-4" data-id="element-277">📘</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-278">
                LIBRO 3 — Planifica tus Comidas
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-279">
                La organización que lo cambia todo
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-280">
                El mayor enemigo de cualquier dieta es la improvisación. Este
                libro te da un sistema de planificación semanal para que nunca
                tengas que pensar qué comes hoy. Abre el libro, sigue el plan,
                cierra el libro.
              </p>
            </div>

            {/* Book 4 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-281">
              <div className="text-5xl mb-4" data-id="element-282">📕</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-283">
                LIBRO 4 — Batch Cooking con Air Fryer
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-284">
                Una tarde para resolver toda la semana
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-285">
                Cocina una vez. Come sano toda la semana. El sistema de Batch
                Cooking adaptado específicamente para freidora de aire. Ahorra
                tiempo, dinero y energía mental cada semana.
              </p>
            </div>

            {/* Book 5 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-286">
              <div className="text-5xl mb-4" data-id="element-287">📓</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-288">
                LIBRO 5 — Postres sin Culpa
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-289">
                El antojo resuelto de una vez
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-290">
                El libro que acaba con el antojo nocturno para siempre. Postres,
                snacks y caprichos saludables hechos en Air Fryer. Cuando llegue
                el momento de debilidad — y llegará — este libro es tu solución.
              </p>
            </div>

            {/* Book 6 */}
            <div className="bg-[#F5F0E8] p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow border border-[#D4A853]/20" data-id="element-291">
              <div className="text-5xl mb-4" data-id="element-292">📔</div>
              <h3 className="text-2xl font-bold text-[#1B4332] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-293">
                LIBRO 6 — Sin Efecto Rebote
              </h3>
              <p className="text-[#D4A853] font-medium mb-4 text-sm uppercase tracking-wide" data-id="element-294">
                El sistema a largo plazo
              </p>
              <p className="text-[#2D5016]/80 leading-relaxed" data-id="element-295">
                La mayoría de las dietas funcionan durante semanas pero luego el
                cuerpo recupera todo lo perdido. Este libro explica exactamente
                cómo mantener los resultados para siempre, sin restricciones
                extremas y sin volver al punto de partida.
              </p>
            </div>
          </div>

          {/* What Each Book Includes */}
          <div className="bg-[#1B4332] text-[#FAF7F2] rounded-3xl p-10 md:p-14 shadow-2xl mb-12" data-id="element-296">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-297">
              Cada libro incluye:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left text-lg" data-id="element-298">
              <p className="flex items-start gap-3" data-id="element-299">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-300">✅</span>
                <span data-id="element-301">
                  Recetas paso a paso con tiempo de preparación exacto
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-302">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-303">✅</span>
                <span data-id="element-304">
                  Ingredientes accesibles en cualquier supermercado de España
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-305">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-306">✅</span>
                <span data-id="element-307">
                  Opciones para toda la familia — no cocinas dos veces
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-308">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-309">✅</span>
                <span data-id="element-310">
                  Sin ingredientes raros ni sustitutos difíciles de encontrar
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-311">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-312">✅</span>
                <span data-id="element-313">Máximo 20 minutos por receta</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-314">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-315">✅</span>
                <span data-id="element-316">Sin contar calorías — el sistema lo hace por ti</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-317">
                <span className="text-[#D4A853] flex-shrink-0" data-id="element-318">✅</span>
                <span data-id="element-319">Productos reales de Mercadona, Lidl y Alcampo</span>
              </p>
            </div>
          </div>
        </FadeInView>
      </div>
    </section>;
}